<script setup>
const props = defineProps({
  legend: { String, required: true },
});
</script>

<template>
  <fieldset class="fieldset">
    <legend>{{ props.legend }}</legend>
    <slot></slot>
  </fieldset>
</template>

<style lang="scss" scoped>
.fieldset {
  margin: 0;
  padding: 15px;
  border-radius: 4px;

  legend {
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
  }
}
</style>
